<template>
	<div>
		<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

			<h1>Movimentação Processual</h1>

			<div class="container text-right" style="text-align: right; font-size: small;">
				<div class="row">
					<div class="col-12">
						<button class="btn_margem" @click="Peticionar();">Pe<u>t</u>icionar</button>
						<button class="btn_margem"><u>P</u>reparar Movimentação</button>
						<button class="btn_margem">Movimentação <u>S</u>ucessiva</button>
						<button class="btn_margem" @click="Voltar();"><u>V</u>oltar</button>

					</div>
				</div>
			</div>

			<div class="container mt-3">
				<div class="row">
					<div class="col-12">
						<table class="table table-striped table-bordered border" style="font-size: small;" v-if="processo" id="printable-section">
							<thead>
								<tr class="text-center">
									<th scope="col" style="background-color: lightgrey; display: none;">id</th>
									<th scope="col" style="background-color: lightgrey;"><!-- Nº Processo --></th>
									<th scope="col" style="background-color: lightgrey;">Assunto</th>
									<th scope="col" style="background-color: lightgrey;">Autor</th>
									<th scope="col" style="background-color: lightgrey;">Réu</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style="text-align: left; display: none;"> {{ processo.id }}</td>
									<td style="text-align: left;"><strong>Processo:</strong>{{ processo.codigo_processo }} <br /><br /><strong>Juízo:</strong> LJO2CIV1J</td>
									<td style="text-align: left;">

										<ul style="list-style: none;">
											<li v-for="assunto in processo.assuntos">
												{{ assunto.descricao }}
											</li>
										</ul>

									</td>
									<td style="text-align: left;">
										<ul>

											<div v-for="parte in processo.partes">
												<li v-if="parte.pivot.polo_ativo === 1" style="list-style-type: none;">
													<span class="parte_ativa">{{ parte.nome }}</span> - {{
														parte.cpf_cnpj
															? (parte.cpf_cnpj.length > 14
																? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
																: '(' + parte.cpf_cnpj + ') Pessoa Física')
															: '(CPF/CNPJ não informado)'
													}}
												</li>
											</div>
										</ul>
									</td>
									<td style="text-align: left;">
										<ul>
											<div v-for="parte in processo.partes">
												<li v-if="parte.pivot.polo_passivo === 1" style="list-style-type: none;">
													<span class="parte_passiva">{{ parte.nome }}</span> - {{
														parte.cpf_cnpj
															? (parte.cpf_cnpj.length > 14
																? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
																: '(' + parte.cpf_cnpj + ') Pessoa Física')
															: '(CPF/CNPJ não informado)'
													}}
												</li>
											</div>
										</ul>

									</td>
								</tr>
							</tbody>
						</table>


					</div>
				</div>
			</div>

			<div class="container mt-2 mb-2" style="font-size: small;">
				<div class="row">
					<div class="col-12 mb-3">
						<label>Motivo de prioridade da petição:</label><br />
						<select v-model="tipo_prioridade_selecionado">
							<option v-for="prioridade in prioridades_peticao" :key="prioridade.id" :value="prioridade.id">
								{{ prioridade.motivo }}
							</option>
						</select>

					</div>
					<div class="col-12 mt-3">
						<label>Evento a ser lançado:</label><br />
						<select v-model="tipo_peticao_selecionado" @change="selecionarTipo">
							<option v-for="tipo in tiposPeticao" :key="tipo.id" :value="tipo.id">
								{{ tipo.descricao }}
							</option>
						</select>
					</div>

					<div class="col-12 mt-3" v-if="user.is_admin">
						<label>Prazo:</label><br />
						<div class="col-12" style="font-size: small;" title="No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.">
							<input type="date" v-model="prazo_peticao" title="No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.">&nbsp;
							<br /><span style="font-size: smaller;"><i>No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.</i></span>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12 form-container mb-3 mt-3" v-if="tipo_peticao_selecionado != ''" style="border: 1px solid red; font-size: small;">
				<div class="form-title" style="color: red;">Atenção!</div>
				<div class="row">
					<div class="col-12">
						<p>
							Senhor Procurador:<br />
							Deixe marcado a <strong>caixa de seleção abaixo</strong> se a petição apresentada destinar-se ao ato processual que for decorrente da intimação<br />
							Com isso, <strong>o prazo será fechado automaticamente</strong>. <br />
							Ex: intimação para contrarrazões + petição de contrarrazões (o prazo será fechado).<br /><br />
							Desmarque a <strong>caixa de seleção</strong> se a petição não for decorrente da intimação.<br />
							Com isso, <strong>o prazo continuará aberto</strong>. <br />
							Ex: intimação para contrarações + petição de ciência sem renúncia (o prazo não será fechado).
						</p>
					</div>
				</div>
			</div>

			<div class="col-12 form-container mb-3 mt-3" v-if="tipo_peticao_selecionado != ''" style="font-size: small;">
				<div class="form-title">Selecione o(s) prazo(s) a ser(em) fechado(s) (OPCIONAL):</div>
				<div class="row">
					<div class="col-12">
						<ul style="list-style: none; padding-left: 0;">
							<!-- opção "Nenhum" -->
							<li>
								<input type="checkbox" :checked="referente_ao_evento === null" @change="toggleEventoReferencia(null)" />
								Nenhum
							</li>

							<!-- eventos -->
							<li v-for="(peticao, index) in [...peticoes].reverse()" :key="peticao.id">
								<input type="checkbox" :checked="referente_ao_evento === peticao.id" @change="toggleEventoReferencia(peticao.id)" />
								{{ peticao.descricao }} - Ref. Evento {{ peticoes.length - index }} - {{ peticao.usuario_criador.name }}
								<template v-if="peticao.prazo && peticao.concluido == 0">
									- Prazo: {{ formatDateSemHora(peticao.prazo) }}
								</template>
								<template v-if="peticao.concluido == 1">
									- Concluído em {{ formatDateSemHora(peticao.concluido_em) }}
								</template>
							</li>
						</ul>


					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="col-12 form-container mb-3">
						<div class="row">
							<div class="col-12" style="font-size: small; text-align: center;">
								<a href="#" @click.prevent="" class="link_documentos">Adicionar mais Documentos</a>&nbsp;&nbsp;|&nbsp;&nbsp;
								<a href="#" @click.prevent="openEditor" class="link_documentos">Digitar Documento</a>&nbsp;&nbsp;|&nbsp;&nbsp;
								<a href="#" @click.prevent="" class="link_documentos">Opções Avançadas</a>
							</div>

							<documento-editor-component ref="documentoEditor"></documento-editor-component>

						</div>

						<div class="row">
							<div class="col-12 form-container mb-3" style="width: 80%; font-size: small; margin-left: auto; margin-right: auto;">
								<div class="form-title">[ - ]Documento 1</div>
								<div class="row">
									<div class="col-2">
										Arquivo: <span class="material-icons" style="font-size: small;" :title="uploadDocumentoTiposPermitidosTitle">
											help
										</span>
									</div>
									<div class="col-10">
										<input type="file" ref="fileInput"><br />
										<p v-if="$store.state.documentPathTemporario" style="font-weight: bold;">Petição digitada anexada.</p>
									</div>
								</div>
								<div class="row mt-2">
									<div class="col-1">
										Tipo:
									</div>
									<div class="col-5" style="position: relative;">
										<input type="text" class="form-control form-control-sm" v-model="tipo_documentos_peticao_selecionado" @input="buscarDocumentosPeticao" />
										<ul v-if="tiposDocumentosPeticao.length" class="lista-autocomplete">
											<li v-for="tipo in tiposDocumentosPeticao" @click="selecionarTipoDocumento(tipo)" class="item-autocomplete">
												{{ tipo.descricao }}
											</li>
										</ul>
									</div>
									<div class="col-2">
										<a href="#" @click.prevent="buscarTodosDocumentosPeticao" style="color: black;">Listar Todos</a>
									</div>
									<div class="col-1">
										Sigilo:
									</div>
									<div class="col-3">
										<select class="form-control form-control-sm custom-select-sm custom-dropdown" v-model="nivel_sigilo_selecionado">
											<option :value="0">Sem Sigilo (Nível 0)</option>
											<option :value="1">Com Sigilo (Nível 1)</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12" style="font-size: small; text-align: center;">
								<button type="button" style="margin-right: 3px; cursor: pointer; " @click="confirmarSelecaoDocumentos">
									<label style="vertical-align: middle; cursor: pointer;">Confirma seleção de documentos</label>
								</button>
							</div>
						</div>

						<div class="row mt-4">
							<div class="col-12" style="font-size: small;">
								<p style="text-align: center;">Documentos selecionados e ainda não utilizados em movimentação</p>
								<table class="table table-striped table-bordered mt-2 border">
									<thead>
										<tr class="text-center">
											<th scope="col" style="background-color: lightgrey; display: none;">id</th>
											<th scope="col" style="background-color: lightgrey;">Seq <span class="material-icons-outlined" style="font-size: small;">help</span></th>
											<th scope="col" style="background-color: lightgrey;">Formato</th>
											<th scope="col" style="background-color: lightgrey;">Nome Documento</th>
											<th scope="col" style="background-color: lightgrey;">Tamanho</th>
											<th scope="col" style="background-color: lightgrey;">Tipo Documento</th>
											<th scope="col" style="background-color: lightgrey;">Sigilo</th>
											<th scope="col" style="background-color: lightgrey;">Data Envio</th>
											<th scope="col" style="background-color: lightgrey;">Assoc. Assinaturas Digitais</th>
											<th scope="col" style="background-color: lightgrey;">Obs</th>
											<th scope="col" style="background-color: lightgrey;">Excluir</th>
										</tr>
									</thead>
									<tbody v-if="peticao_id && documentos && documentos.length > 0">
										<tr v-for="documento in documentos">
											<td style="display: none;">{{ documento.id }}</td>
											<td style="text-align: left;">

												<button type="button" class="btn btn-sm" @click="moverDocumento(documento, 'cima')">
													<span class="material-icons-outlined">keyboard_arrow_up</span>
												</button>
												<button type="button" class="btn btn-sm" @click="moverDocumento(documento, 'baixo')">
													<span class="material-icons-outlined">expand_more</span>
												</button>
												{{ documento.order }}
											</td>
											<td style="text-align: left;">{{ documento.extensao_arquivo }}</td>
											<td style="text-align: left;">{{ documento.descricao }}</td>
											<td style="text-align: center;">{{ documento.tamanho_arquivo }} bytes</td>
											<td style="text-align: center;">
												<button type="button" class="btn btn-sm btn-light botao-grid" @click="">
													<label class="label_botao">Alterar</label>
												</button>
												{{ documento.tipo_documento_peticao.descricao.slice(0, 7) }}
											</td>
											<td style="text-align: center;">
												<button type="button" class="btn btn-sm btn-light botao-grid" @click="AlterarSigilo(documento)">
													<label class="label_botao">Alterar</label>
												</button>
												{{ documento.confidencial == 0 ? 'Sem Sigilo (Nível 0)' : 'Com Sigilo (Nível 1)' }}
											</td>
											<td style="text-align: center;">{{ formatDate(documento.updated_at) }}</td>
											<td style="text-align: center;">
												<button type="button" class="btn btn-sm btn-light botao-grid">
													<label class="label_botao">Associar</label>
												</button>(Opcional)
											</td>
											<td style="text-align: center;"><!-- OBS NÃO SABEMOS A INFORMAÇÃO QUE VAI AQUI --></td>
											<td style="text-align: center;">
												<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerDocumento(documento.id)">
													<img :src='BASE_URL + "imagens/icons/assuntos_remover.png"' width="20px" />
												</button>
											</td>
										</tr>
									</tbody>
								</table>

								<hr />

							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- #region caixa de análise da IA -->
			<div v-if="funcionalidade_IA_ativa == true" class="ia-container">
				<hr class="ia-divider" />
				<!-- mensagem de erro quando houver algum problema com a IA -->
				<div v-if="exibirMensagemErro == true" class="ia-error-message">
					<div>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
							<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
							<path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
						</svg>
						<p id="mensagem-retorno">{{ mensagemRetornoIA }}</p>
					</div>
					<span class="ia-modal-close" @click="fecharMensagemErro">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
							<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
						</svg>
					</span>
				</div>

				<div class="ia-content-wrapper">
					<div class="ia-left-section">
						<div>
							<h1 class="ia-title">
								Análise da petição com Inteligência Artificial
							</h1>
							<h2 class="ia-subtitle">
								Ferramenta pedagógica exclusiva do TWM Simuladores.
							</h2>
							<button class="ia-button" type="button" @click="AnalisarComIA()" :disabled="botao_analisarIA_desabilitado">
								<span v-if="botao_analisarIA_desabilitado">
									<span class="ia-spinner"></span> Gerando com
									IA...
								</span>
								<span v-else>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
										<path fill-rule="evenodd" stroke="currentColor" stroke-width="2" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
									</svg>
									<span>Analisar petição com IA</span>
								</span>
							</button>

							<!-- Botão para verificar as sugestões somente se as sugestões já estiverem carregadas -->
							<button class="ia-button-result" type="button" v-if="exibirBotaoSugestao" @click="abrirModalIA">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
									<path fill-rule="evenodd" stroke="currentColor" stroke-width="2" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
								</svg>
								<span>Verificar Sugestão(ões)</span>
							</button>
						</div>
						<div class="ia-image-container">
							<img class="ia-image" :src="BASE_URL + 'imagens/personagem.png'" alt="Personagem" />
						</div>
					</div>
					<!-- end div -->
					<div class="ia-right-section">
						<h1 class="ia-title">Como usar?</h1>
						<ol class="ia-list">
							<li>Efetue sua petição normalmente.</li>
							<li>
								Antes de salvar, clique em "Analisar Petição com
								IA".
							</li>
							<li>Receba sugestões de melhoria.</li>
							<li>Avalie se as sugestões são viáveis.</li>
							<li>
								Nenhuma alteração será feita automaticamente no
								documento original.
							</li>
						</ol>
					</div>
				</div>
			</div>
			<!-- #endregion -->
		</div>

		<!-- #region Modal da Sugestão da IA -->
		<div v-if="mostrarModal_IA" class="ia-modal">
			<div class="ia-modal-content">
				<span class="ia-modal-close" @click="fecharModalIA">&times;</span>

				<!-- header -->
				<div class="suggestions-header">
					<!-- conteudo -->
					<div class="suggestions-header-content">
						<h2 class="suggestions-header-title">
							<svg class="suggestions-header-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1" />
							</svg>
							<span>Sugestões da nossa IA</span>
						</h2>
						<hr class="suggestions-divider" />
						<!-- Mensagem explicativa -->
						<p class="suggestions-header-info">
							As sugestões apresentadas a seguir foram geradas
							pela nossa Inteligência Artificial avançada, que
							utiliza aprendizado contínuo para oferecer as
							melhores recomendações possíveis. Estas sugestões
							são baseadas em análises de dados e têm como
							objetivo melhorar a eficiência e a qualidade de seu
							trabalho.
						</p>
					</div>
					<!-- personagem -->
					<div class="suggestions-header-robot">
						<img class="ia-image" :src="BASE_URL + 'imagens/personagem.png'" alt="Personagem" />
					</div>
				</div>

				<!-- Layout flexível para o menu lateral e o corpo da sugestão -->
				<div class="suggestions-layout">
					<!-- Menu lateral com horários das sugestões -->
					<div class="suggestions-menu">
						<p class="suggestions-menu-title">
							Histórico de Pesquisa
						</p>
						<ul style="list-style: none">
							<li v-for="(sugestao, index) in sugestoesIA" :key="index" @click="mostrarSugestao(index)" :class="{
								'selected-suggestion':
									sugestaoSelecionada === sugestao,
							}">
								Sugestão recebida em
								{{ formatDate(sugestao.created_at) }}
							</li>
						</ul>
					</div>

					<!-- Corpo para exibir a sugestão selecionada -->
					<div class="suggestions-content">
						<h3>Conteúdo da Análise</h3>
						<template v-if="sugestaoSelecionada">
							<div v-html="sugestaoSelecionada.resposta_recebida"></div>
						</template>
						<template v-else>
							<div class="suggestions-loading-container">
								<div class="suggestions-spinner-border" role="status">
									<span class="sr-only">Carregando...</span>
								</div>
								<span class="suggestions-loading-text">Gerando sugestões, por favor
									aguarde...</span>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<!-- #endregion AI HTML -->

		<assistente-juridico
			v-if="assistenteHabilitado && processoIdValido"
			:processo-id="Number(processo.id)"
			:peticao-id="peticao_id || null"
			tela="movimentacao"
		></assistente-juridico>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				uploadDocumentoMaxMb: Number(window.Laravel.UPLOAD_DOCUMENTO_MAX_MB) || 10,

				selecionar_arquivo: '',
				tipo_peticao_selecionado: '',
				nivel_sigilo_selecionado: 0,

				tipo_peticao_selecionado_id: '',
				tipo_peticao_selecionado_descricao: '',
				tiposPeticao: [],

				tiposDocumentosPeticao: [],
				tipo_documentos_peticao_selecionado: '',
				tipo_documentos_peticao_selecionado_id: '',

				documentos: [],

				peticoes: [],

				peticao_id: '',

				tipo_prioridade_selecionado: '',
				prioridades_peticao: [],

				referente_ao_evento: null, // id da petição evento que está sendo referenciada
				prazo_peticao: null,

				// #region AI Variables
				mostrarModal_IA: false,
				exibirBotaoSugestao: false,
				botao_analisarIA_desabilitado: false,
				exibirMensagemErro: false,
				mensagemRetornoIA: "",
				mensagemErroTimeout: null,
				funcionalidade_IA_ativa: false,
				funcionalidade_IA_apenas_admin_ativa: false,
				sugestoesIA: [],
				sugestaoSelecionada: null,
				// #endregion
			};
		},
		props: {
			user: {
				type: Object,
				required: true,
			},
			processo: {
				type: Object,
			},
		},
		computed: {
			assistenteHabilitado() {
				const configuracao = typeof window.Laravel !== "undefined" ? window.Laravel : {};
				const valoresAtivos = [true, 1, "1", "true"];

				return valoresAtivos.includes(configuracao.ATIVAR_FUNCIONALIDADE_IA)
					&& valoresAtivos.includes(configuracao.ativarAssistenteJuridico);
			},
			processoIdValido() {
				const processoId = Number(this.processo && this.processo.id);

				return Number.isInteger(processoId) && processoId > 0;
			},
			uploadDocumentoTiposPermitidosTitle() {
				return `Tipos de arquivos permitidos:
						Documentos PDF e KML (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Áudio: MP3, WMA e WAV (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Imagens: JPEG, JPG, PNG e GIF (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Vídeos: MP4, WMV, MPG e MPEG (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)`;
			},
		},
		methods: {
			uploadDocumentoMaxSizeBytes() {
				return this.uploadDocumentoMaxMb * 1024 * 1024;
			},
			uploadDocumentoMaxMessage() {
				return `Em conformidade com o sistema oficial, só são permitidos arquivos com tamanho máximo de ${this.uploadDocumentoMaxMb} MB`;
			},
			uploadDocumentoErrorMessage(error) {
				if (error.response && error.response.status === 422 && error.response.data && error.response.data.message) {
					return error.response.data.message;
				}

				return "Erro ao adicionar o arquivo!";
			},
			// #region AI methods
			abrirModalIA() {
				this.BuscarSugestoesIA();
				this.mostrarModal_IA = true;
			},
			fecharMensagemErro() {
				this.exibirMensagemErro = false;
			},
			mostrarAlertaErro(mensagem) {
				this.mensagemRetornoIA = mensagem;
				this.exibirMensagemErro = true;

				if (this.mensagemErroTimeout) {
					clearTimeout(this.mensagemErroTimeout);
				}

				this.mensagemErroTimeout = setTimeout(() => {
					this.exibirMensagemErro = false;
					this.mensagemErroTimeout = null;
				}, 5000);

				alert(mensagem);
			},
			fecharModalIA() {
				this.mostrarModal_IA = false;
			},
			formatDate(dateString) {
				const options = {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
					hour: "2-digit",
					minute: "2-digit",
				};
				return new Date(dateString).toLocaleDateString("pt-BR", options);
			},
			formatText(texto_formatar) {
				// Converte markdown-like para HTML básico
				return texto_formatar
					.replace(/^### (.*$)/gim, "<h4>$1</h4>")
					.replace(/^\s*\n\* (.*)/gim, "<ul>\n<li>$1</li>\n</ul>")
					.replace(/^\* (.*)/gim, "<li>$1</li>")
					.replace(/^\s*\n\d\. (.*)/gim, "<ul>\n<li>$1</li>\n</ul>")
					.replace(/\*\*(.*)\*\*/gim, "<strong>$1</strong>")
					.replace(/\n$/gim, "<br /><br />");
			},
			ConfigurarIA() {
				if (this.funcionalidade_IA_apenas_admin_ativa === false) {
					this.funcionalidade_IA_ativa =
						typeof window.Laravel !== "undefined" ?
							window.Laravel.ATIVAR_FUNCIONALIDADE_IA :
							false;
				} else {
					if (this.user && this.user.isAdmin == 1) {
						this.funcionalidade_IA_ativa =
							typeof window.Laravel !== "undefined" ?
								window.Laravel.ATIVAR_FUNCIONALIDADE_IA :
								true;
					}
				}
			},
			mostrarSugestao(index) {
				this.sugestaoSelecionada = this.sugestoesIA[index];
			},
			BuscarSugestoesIA() {
				const processoId =
					(this.processo && this.processo.id) ||
					(this.$store && this.$store.state && this.$store.state.processo && this.$store.state.processo.id) ||
					(this.$store && this.$store.state && this.$store.state.processoId) ||
					null;

				const peticaoId =
					this.peticao_id ||
					(Array.isArray(this.peticoes) && this.peticoes.length > 0
						? this.peticoes[this.peticoes.length - 1].id
						: null);

				if (!processoId) {
					this.sugestoesIA = [];
					return;
				}

				const peticaoIdParam = peticaoId ? peticaoId : "null";

				axios
					.get(
						`${this.BASE_URL}sugestoes_ia_buscar/${processoId}/peticaoid/${peticaoIdParam}`
					)
					.then((res) => {
						if (res.data && Array.isArray(res.data.sugestoes)) {
							this.sugestoesIA = res.data.sugestoes.map(
								(sugestao) => {
									let respostaCompleta =
										sugestao.resposta_recebida || "";
									let indexStart =
										respostaCompleta.indexOf("``html");
									if (indexStart !== -1) {
										respostaCompleta =
											respostaCompleta.substring(indexStart);
									}
									respostaCompleta = respostaCompleta
										.replace(/`html/g, "")
										.replace(/`/g, "")
										.trim();

									return {
										created_at: sugestao.created_at,
										resposta_recebida: respostaCompleta,
										modelo: sugestao.modelo,
										conteudo_enviado: sugestao.conteudo_enviado,
										data_resposta: sugestao.data_resposta,
									};
								}
							);
						}
					})
					.catch((error) => {
						console.error("Erro ao buscar sugestões da IA:", error);
					});
			},
			AnalisarComIA() {
				this.sugestaoSelecionada = null;

				let conteudo_editor = "";
				if (this.$refs.documentoEditor) {
					conteudo_editor = this.$refs.documentoEditor.editorData || "";
				}

				let uploadedFiles = [];
				if (this.documentos && this.documentos.length > 0) {
					uploadedFiles = this.documentos.map(doc => ({
						id: doc.id,
						hash_name: doc.nome_arquivo_servidor || doc.hash_name || doc.caminho_arquivo || doc.caminho || doc.descricao,
						path: doc.caminho_arquivo || doc.documento || doc.path,
						name: doc.descricao,
						mime: doc.mime_arquivo || "application/pdf",
						isAlreadyUploaded: true
					}));
				}

				const tem_texto = conteudo_editor !== "" && conteudo_editor !== "<p></p>";
				const tem_arquivos = uploadedFiles.length > 0;

				if (!tem_texto && !tem_arquivos) {
					this.mostrarAlertaErro(
						"Para analisar com IA, primeiro digite no editor ou anexe pelo menos um documento e confirme."
					);
					return;
				}

				let payload = {
					conteudo_editor: conteudo_editor,
					uploadedFiles: uploadedFiles,
					userId: this.user ? this.user.id : null,
					peticaoId: this.peticao_id || null,
					processoId: this.processo?.id || null,
				};

				this.botao_analisarIA_desabilitado = true;

				axios.post(`${this.BASE_URL}analisar_chatgpt`, payload)
					.then((res) => {
						if (res.data && res.data.choices && res.data.choices.length > 0) {
							let resposta = res.data.choices[0].message.content
								.replace(/```html/g, "")
								.replace(/```/g, "")
								.trim();

							this.botao_analisarIA_desabilitado = false;

							const novaSugestao = {
								created_at: new Date().toISOString(),
								resposta_recebida: resposta,
							};

							this.sugestaoSelecionada = novaSugestao;
							this.exibirBotaoSugestao = true;
							this.abrirModalIA();
							this.BuscarSugestoesIA();
						} else {
							this.botao_analisarIA_desabilitado = false;
							this.mostrarAlertaErro("A IA não retornou uma análise válida.");
						}
					})
					.catch((error) => {
						console.error(error);
						let msg = "Ocorreu um erro inesperado.";
						if (error.response?.data?.error) msg = error.response.data.error;
						this.mostrarAlertaErro(msg);
						this.botao_analisarIA_desabilitado = false;
					});
			},
			// #endregion

			Voltar() {
				if (confirm("Tem certeza que deseja voltar para a tela anterior sem concluir a movimentação?")) {
					window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
				}
			},
			Peticionar() {
				if (this.peticao_id == '') {
					alert("Não foi possível criar a petição. Nenhum documento foi adicionado.");
					return;
				}

				// Enviar notificação de nova movimentação no processo
				axios.post(this.BASE_URL + "processo/notificar_movimentacao", {
					processo_id: this.processo.id
				})
					.then(response => {
						// Redirecionar após notificação
						window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
					})
					.catch(error => {
						alert("Erro ao enviar notificação aos demais advogados do processo: " + error.message);
						console.log("Erro: " + error);

						// Redirecionar mesmo em caso de erro
						window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
					});
			},
			openEditor() {
				this.$refs.documentoEditor.openEditor();
			},

			formatDate(value) {
				if (value) {
					const date = new Date(value);
					const day = date.getDate().toString().padStart(2, '0');
					const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
					const year = date.getFullYear();
					const hours = date.getHours().toString().padStart(2, '0');
					const minutes = date.getMinutes().toString().padStart(2, '0');
					const seconds = date.getSeconds().toString().padStart(2, '0');
					return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
				}
				return '';
			},

			formatDateSemHora(value) {
				if (value) {
					const date = new Date(value);
					const day = date.getDate().toString().padStart(2, '0');
					const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
					const year = date.getFullYear();
					//const hours = date.getHours().toString().padStart(2, '0');
					//const minutes = date.getMinutes().toString().padStart(2, '0');
					//const seconds = date.getSeconds().toString().padStart(2, '0');
					return `${day}/${month}/${year}`;
				}
				return '';
			},

			async buscarDocumentosPeticao() {
				if (this.tipo_documentos_peticao_selecionado.length > 1) {
					try {
						const response = await axios.get(this.BASE_URL + `processo/buscar-documentos-peticao?query=${this.tipo_documentos_peticao_selecionado}`);
						this.tiposDocumentosPeticao = response.data;
					} catch (error) {
						console.error(error);
						// Tratamento de erro
					}
				} else {
					this.tiposDocumentosPeticao = [];
				}
			},
			async buscarTodosDocumentosPeticao() {
				try {
					const response = await axios.get(this.BASE_URL + 'processo/buscar-documentos-peticao?all=true');
					this.tiposDocumentosPeticao = response.data;
				} catch (error) {
					console.error(error);
				}
			},
			async buscarTipoPeticao() {
				if (this.tipo_peticao_selecionado.length > 1) {
					try {
						const response = await axios.get(this.BASE_URL + `processo/buscar-tipo-peticao?query=${this.tipo_peticao_selecionado}`);
						this.tiposPeticao = response.data;

					} catch (error) {
						console.error(error);
						// Tratamento de erro
					}
				} else {
					this.tiposDocumentosPeticao = [];
				}
			},
			selecionarTipoDocumento(tipo) {
				this.tipo_documentos_peticao_selecionado = tipo.descricao;
				this.tipo_documentos_peticao_selecionado_id = tipo.id;
				this.tiposDocumentosPeticao = [];
			},
			async buscarTodosTipos() {
				try {
					const response = await axios.get(this.BASE_URL + 'processo/buscar-tipo-peticao?all=true');
					this.tiposPeticao = response.data;
				} catch (error) {
					console.error(error);
				}
			},
			async buscarPrioridadesPeticao() {
				try {
					const response = await axios.get(this.BASE_URL + 'processo/buscar-prioridades-peticao?all=true');
					this.prioridades_peticao = response.data;

				} catch (error) {
					console.error(error);
				}
			},
			selecionarTipo() {

				console.log(this.tiposPeticao);
				const tipoSelecionado = this.tiposPeticao.find(tipo => tipo.id === this.tipo_peticao_selecionado);
				if (tipoSelecionado) {
					// Aqui você pode fazer qualquer lógica adicional com o tipo selecionado
					this.tipo_peticao_selecionado_descricao = tipoSelecionado.descricao;
					this.tipo_peticao_selecionado_id = tipoSelecionado.id;
					//this.tiposPeticao = [];
				}
			},

			async confirmarSelecaoDocumentos() {
				if (this.tipo_peticao_selecionado_id == '') {
					alert("Nenhum Evento selecionado.");
					return;
				}

				let documentPath = this.$store.state.documentPathTemporario;

				if (!documentPath) { //Se o arquivo não foi digitado, ele precisa estar selecionado no campo input

					// Pega o arquivo do input
					const file = this.$refs.fileInput.files[0];

					if (!file) {
						alert("Por favor, selecione um arquivo ou digite a petição em 'Digitar Documento'.");
						return;
					}

					// Validações dos tipos de arquivos e tamanhos
					const validTypes = ['application/pdf', 'application/vnd.google-earth.kml+xml', 'audio/mpeg', 'audio/wma', 'audio/wav', 'image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/x-ms-wmv', 'video/mpeg'];
					const maxSize = this.uploadDocumentoMaxSizeBytes();

					if (!validTypes.includes(file.type)) {
						alert("Tipo de arquivo não permitido.");
						return;
					}

					if (file.size > maxSize) {
						alert(this.uploadDocumentoMaxMessage());
						return;
					}

				}



				let processoId = this.processo.id;
				let nova_peticao = {
					id: '',
					processoId: processoId,
					tipo_id: this.tipo_documentos_peticao_selecionado_id,
					numero: '',
					descricao: this.tipo_peticao_selecionado_descricao,
					pedido_liminar: 0,
					created_por_user_id: this.user.id,
					sigilo: this.nivel_sigilo_selecionado,
					tipo_prioridade_selecionado: this.tipo_prioridade_selecionado,
					documento: documentPath || '',
					referente_ao_evento: this.referente_ao_evento,
					prazo_peticao: this.prazo_peticao,
				}

				if (this.peticao_id == "") { //Cria a petição na adição do primeiro arquivo (digitado ou nao)
					const response = await axios.post(this.BASE_URL + 'criar-peticao', nova_peticao);
					this.$store.commit('setPeticao', response.data);
					this.peticao_id = response.data.id;

					alert("Petição criada com sucesso!");
				}


				let formData = new FormData();
				formData.append('peticao_id', this.peticao_id); // Ajuste conforme necessário
				formData.append('processo_id', processoId); // Supondo que `processoId` esteja disponível
				formData.append('tipo_documentos_peticao_selecionado_id', this.tipo_documentos_peticao_selecionado_id);
				formData.append('nivel_sigilo_selecionado', this.nivel_sigilo_selecionado);
				let created_por_user_id = this.user.id;
				formData.append('created_por_user_id', created_por_user_id);

				if (documentPath) {
					// Caso a petição tenha sido digitada
					formData.append('documentPath', documentPath); // Caminho do arquivo no servidor
					formData.append('peticao_digitada', 1); // Indica que a petição foi digitada
					// Não há necessidade de incluir `tamanho_arquivo`, `mime_arquivo` e `extensao_arquivo` pois o arquivo já está no servidor
				} else {
					// Caso o arquivo tenha sido selecionado através do input
					const file = this.$refs.fileInput.files[0];
					formData.append('documento', file);
					formData.append('peticao_digitada', 0);
					formData.append('tamanho_arquivo', file.size);
					formData.append('mime_arquivo', file.type);
					let extensao_arquivo = file.name.split('.').pop();
					formData.append('extensao_arquivo', extensao_arquivo);
				}

				// Dentro do try block da sua função confirmarSelecaoDocumentos, após o upload
				try {
					const responseUpload = await axios.post(this.BASE_URL + 'upload-documento', formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					});

					this.documentos.push(responseUpload.data);
					// Atualiza o Vuex state
					this.$store.commit('addDocumentoToPeticao', { peticaoIndex: 0, documento: responseUpload.data });

					alert("Arquivo adicionado com sucesso!");
					this.tipo_documentos_peticao_selecionado = '';
					this.tipo_documentos_peticao_selecionado_id = '';
					this.$store.commit('clearDocumentPathTemporario'); //Limpa a variável da petição temporária.

					if (!documentPath) {
						// Limpa o input de arquivo apenas se um arquivo foi selecionado manualmente
						this.$refs.fileInput.value = '';

					}
				} catch (error) {
					console.error("Erro ao adicionar o arquivo:", error);
					alert(this.uploadDocumentoErrorMessage(error));
				}
			},

			toggleEventoReferencia(id) {
				// se clicar no que já está selecionado, limpa (volta para "nenhum")
				if (this.referente_ao_evento === id) {
					this.referente_ao_evento = null;
				} else {
					this.referente_ao_evento = id;
				}
			},

			async buscarPeticoes(processo_id) {
				try {
					const response = await axios.get(this.BASE_URL + 'buscar_peticoes_processo/' + processo_id);
					this.peticoes = response.data;
				} catch (error) {
					console.error(error);
				}
			},


			AlterarSigilo(documento) {
				documento.confidencial = documento.confidencial === 0 ? 1 : 0;
				const response = axios.post(this.BASE_URL + 'processo-alterar-sigilo-documento', {
					documento_id: documento.id,
					confidencial: documento.confidencial
				});
			},

			async moverDocumento(documentoClicado, direcao) {

				//const documentos = this.documentos;


				const index = this.documentos.findIndex(doc => doc.id === documentoClicado.id);
				if (index === -1) return; // Documento não encontrado

				let newIndex = index + (direcao === 'cima' ? -1 : 1);
				if (newIndex < 0 || newIndex >= this.documentos.length) return; // Checa limites

				// Atualiza os valores de 'order' para refletir a nova ordem
				this.documentos[index].order = newIndex + 1;
				this.documentos[newIndex].order = index + 1;

				// Reordena o array de documentos baseado no novo 'order'
				this.documentos.sort((a, b) => a.order - b.order);


				const documentos = this.documentos;
				const response_docs = await axios.post(`${this.BASE_URL}atualizar-ordem-documentos`, { documentos });



				//this.documentos = documentos; //Para ordenar na tela.


			},

			async removerDocumento(documentoId) {
				if (window.confirm('Tem certeza que deseja remover este documento?')) {
					try {
						const response = await axios.delete(`${this.BASE_URL}processo-remover-documento/${documentoId}`);

						const documentos = this.documentos;
						const indexRemovido = documentos.findIndex(doc => doc.id === documentoId);
						if (indexRemovido !== -1) {
							// Captura o valor de order do documento removido
							const orderRemovido = documentos[indexRemovido].order;

							// Remove o documento do array
							documentos.splice(indexRemovido, 1);

							// Ajusta o valor de order para os documentos seguintes
							documentos.forEach(doc => {
								if (doc.order > orderRemovido) {
									doc.order -= 1;
								}
							});

							// Opcionalmente, reordena os documentos por segurança
							documentos.sort((a, b) => a.order - b.order);


							const response_docs = await axios.post(`${this.BASE_URL}atualizar-ordem-documentos`, { documentos });

							// Aqui você pode adicionar uma chamada de API para atualizar a ordem no backend
						}
					} catch (error) {
						console.error('Erro ao remover o documento:', error);
					}
				}
			},

		},
		mounted() {

			this.buscarTodosTipos();
			this.buscarPrioridadesPeticao();
			this.buscarPeticoes(this.processo.id);
			this.ConfigurarIA();
		},
		watch: {
			sugestoesIA(newVal) {
				if (newVal.length > 0) {
					this.mostrarSugestao(0);
				}
			},
		}
	};
</script>

<style scoped>
	@import url("../../../css/ia.css");

	h1 {
		font-size: 26px;
	}

	.btn_margem {
		margin-left: 7px;
	}



	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
	}

	.link_documentos {
		text-decoration: underline;
		color: black;
	}

	.form-control-smaller {
		height: calc(1.5em + 0.5rem + 2px);
		padding: 0.25rem 0.5rem;
	}


	.lista-autocomplete {
		position: absolute;
		z-index: 1000;
		/* Assegura que a lista fique acima de outros conteúdos */
		width: 100%;
		/* Faz a lista ocupar toda a largura do contêiner pai */
		background-color: #fff;
		/* Ou qualquer cor que se adeque ao seu design */
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
		/* Adiciona sombra para um efeito de elevação */
		max-height: 300px;
		/* Limita a altura da lista e torna-a rolável */
		overflow-y: auto;
		/* Adiciona barra de rolagem vertical se necessário */
		border: 1px solid #ccc;
		/* Adiciona uma borda sutil (opcional) */
		border-top: none;
		/* Remove a borda superior para se fundir melhor com o campo de entrada */
		list-style-type: none;
	}

	.item-autocomplete {
		padding: 2px;
		cursor: pointer;
	}

	.item-autocomplete:hover {
		background-color: #f5f5f5;
		/* Muda a cor de fundo ao passar o mouse */
	}


	.botao-grid {
		margin-right: 2px;
		width: 90px;
		cursor: pointer;
	}

	.label_botao {
		color: #007BFF;
		vertical-align: middle;
		cursor: pointer;
	}

</style>
